import * as React from "react";
import { forwardRef } from "react";
const SvgDelete = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 4.5H18V2.5H6V4.5ZM20 7.5H18V20.5H6V7.5H4V5.5H6H18H20V7.5ZM8 7.5H16V18.5H8V7.5Z", fill: "currentcolor" }));
const ForwardRef = forwardRef(SvgDelete);
export default ForwardRef;
